import { splitOnSearchTerm } from './utils';

type HighlightedTextProps = {
  text: string;
  /** Normalised search term (see `normaliseSearchTerm`); empty leaves `text` alone. */
  searchQuery: string;
};

/**
 * Washes the parts of `text` that match the live search term, so a filtered
 * result shows the user *why* it came back rather than leaving them to hunt for
 * the word themselves. With no term it renders the plain string, keeping the
 * unfiltered panel's markup as it was before the search existed.
 *
 * `text-inherit` on the `<mark>` is deliberate: the browser default paints
 * marked text black, which would fight the greyed-out styling the panel uses
 * for answers that found nothing in the records.
 */
export function HighlightedText({ text, searchQuery }: HighlightedTextProps) {
  if (!searchQuery) return <>{text}</>;

  return (
    <>
      {splitOnSearchTerm(text, searchQuery).map((segment, index) =>
        segment.isMatch ? (
          <mark key={index} className="bg-theme-search-highlight rounded-[2px] text-inherit">
            {segment.text}
          </mark>
        ) : (
          segment.text
        ),
      )}
    </>
  );
}
